module.exports = __webpack_public_path__ + "img/thumb_28.3d3787f7.jpg";